<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-button type="primary" icon="plus" @click="editInfo()">添加会员等级</el-button>
        </el-col>
      </el-row>
      <el-table :data="memberData" :height="wheight-210"  v-loading="loading"  @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" label="全选"></el-table-column>
        <el-table-column prop="member_lv_id" label="ID" width="130"></el-table-column>
        <el-table-column prop="name" label="等级名称" width="130"></el-table-column>
        <el-table-column prop="member_lv" label="会员等级" width="130"></el-table-column>
        <el-table-column label="等级logo" width="100">
          <template slot-scope="scope">
            <el-popover placement="right" width="240" trigger="hover" >
            <img :src="scope.row.lv_logo" style="width:100%;">
            <el-button type="text" slot="reference"><img style="width:50px;height:50px;" :src="scope.row.lv_logo"></el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="att_ratio"   label="分佣比例" width="130"></el-table-column>
        <el-table-column prop="new_reward"  label="拉新奖励" width="130"></el-table-column>
        <el-table-column prop="min_withdraw"  label="最低提现" width="130"></el-table-column>
        <el-table-column prop="lv_remark"  label="会员等级备注" width="130"></el-table-column>
        <el-table-column label="操作" width="130">
          <template slot-scope="scope">
            <el-button type="text" @click="editInfo(scope.row)" class="btn-gap">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>


      <el-dialog  :title="dialogTitle" class="right-dialog" :visible.sync="editInfoDialog" :before-close="handleCancelLabelsDialog">
      <template>
        <el-form>
          <el-form-item label-width="100px" label="等级名称">
            <el-input v-model="updateForm.name" placeholder="等级名称"></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="会员等级">
            <el-input type="number" v-model="updateForm.member_lv" placeholder="会员等级"></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="等级logo" prop="lv_logo">
            <div @click="handleImgPicker('lv_logo')" class="upload-box">
              <img v-if="updateForm.lv_logo" :src="updateForm.lv_logo" class="avatar"/>
              <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
            </div>
            <!-- <div class="frm-tips">
              等级logo|只能上传jpg/png文件，且不超过2M
            </div> -->
          </el-form-item>
          <el-form-item label-width="100px" label="分佣比例">
            <el-input v-model="updateForm.att_ratio" placeholder="分佣比例"></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="拉新奖励">
            <el-input v-model="updateForm.new_reward" placeholder="拉新奖励"></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="最低提现">
            <el-input v-model="updateForm.min_withdraw" placeholder="最低提现"></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="会员等级备注">
            <el-input v-model="updateForm.lv_remark" placeholder="会员等级备注"></el-input>
          </el-form-item>
          <el-form-item class="content-center">
            <el-button type="primary" @click="editInfoSubmit()">确定</el-button>
          </el-form-item>
        </el-form>
      </template>
    </el-dialog>

    <imgPicker
      :dialog-visible="imgDialog"
      :sc-status="isGetImage"
      @chooseImg="pickImg"
      @closeImgDialog="closeImgDialog"
    ></imgPicker>

    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import {membersLvList,updateMemberLvInfo} from '../../../api/sharer'
import imgPicker from "@/components/imageselect";
import {mapGetters} from "vuex";
export default {
  components: { imgPicker },
  data() {
    return {
      dialogTitle:"",
      loading: false,
      memberData: [],
      params: {
        page: 1,
        pageSize: 10
      },
      updateForm: {
        member_lv_id: '',
        member_lv: '',
        name: '',
        lv_logo: '',
        att_ratio: '',
        new_reward: '',
        min_withdraw: '',
        lv_remark:''
      },
      editInfoDialog:false,
      pickerImgType: "",
      imgDialog: false,
      isGetImage: false,
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    getMembers(filter) {
      this.loading = true
      membersLvList(filter).then(response => {
        this.memberData = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.loading = false
      })
    },
    editInfo(row = ''){
      this.editInfoDialog = true
      if(row){
        this.updateForm.member_lv_id = row.member_lv_id
        this.updateForm.name = row.name
        this.updateForm.member_lv = row.member_lv
        this.updateForm.lv_logo = row.lv_logo
        this.updateForm.att_ratio = row.att_ratio
        this.updateForm.new_reward = row.new_reward
        this.updateForm.min_withdraw = row.min_withdraw
        this.updateForm.lv_remark = row.lv_remark
        this.dialogTitle = '编辑会员等级'
      }else{
        this.dialogTitle = '添加会员等级'
        this.updateForm = {member_lv_id: '', name: '', member_lv: '', lv_logo: '', att_ratio: '', new_reward: '', min_withdraw: '',  lv_remark: ''}
      }
    },
    editInfoSubmit(){
      // console.log(this.updateForm);
        updateMemberLvInfo({member_lv_id: this.updateForm.member_lv_id, name: this.updateForm.name, member_lv: this.updateForm.member_lv, lv_logo: this.updateForm.lv_logo, att_ratio: this.updateForm.att_ratio, new_reward: this.updateForm.new_reward, min_withdraw: this.updateForm.min_withdraw, lv_remark: this.updateForm.lv_remark}).then(res => {
            this.$message({ type: 'success', message: '更新成功'})
            this.editInfoDialog = false
            this.getMembers(this.params)
        })
    },
    handleCancelLabelsDialog() {
      this.editInfoDialog = false
    },
    pickImg(data) {
      this.updateForm[this.pickerImgType] = data.url;
      // this.updateForm.lv_logo = data.url;
      this.imgDialog = false;
    },
    handleImgPicker(pickerImgType) {
      this.pickerImgType = pickerImgType;
      this.imgDialog = true;
      this.isGetImage = true;
    },
    closeImgDialog() {
      this.imgDialog = false;
      this.isGetImage = false;
    },
    handleSelectionChange(val) {
      console.log(val)
    },
  },
  mounted () {
    this.getMembers(this.params)
    let param = {
      page: 1,
      pageSize: 100
    }
  },
  watch: {
    // 分页全选-监听数据变化
    memberData: {
      handler (value) {
        if (this.allCheck) {

          this.memberData.forEach(row => {
            if (row) {
              this.$refs.multipleTable.toggleRowSelection(row, true)
            }
          });
        }
      },
      deep: true
    },
  }
}
</script>



// WEBPACK FOOTER //
// list.vue?6a07a71d